import { getTemplate } from "../template-helper";
import { uuidv4 } from "../../util/utils";
import { error } from "../../util/dialogs";
import { tr } from "../../util/locales";

const COMPONENT_NAME = "z-wizard" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL_BASE = "/static/libs/components/" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        getTemplate(TEMPLATE_ID+"-title", TEMPLATE_URL_BASE+"z-wizard-title.html").then((templateTitle)=>{
            getTemplate(TEMPLATE_ID+"-contents", TEMPLATE_URL_BASE+"z-wizard-contents.html").then((templateContents)=>{
        
                class WizardComponent extends HTMLElement {
                    constructor() {
                        super();

                        
                    }


                    connectedCallback(){
                        this.init() ;
                    }

                    doImport() {
                
                        let rootNode = this.getRootNode();
                        if(rootNode === this) { return ; }
                        if(!rootNode || !rootNode.getElementById){ return ; }
        
                        let head = rootNode;
                        if(rootNode.head){
                            head = rootNode.head ;
                        }
        
                        const styleTag = rootNode.getElementById("style_z_wizard") ;
                        if(styleTag){ return ; }

                        var sInline = document.createElement('style');
                        sInline.id = "style_z_wizard" ;
                        sInline.setAttribute('type', 'text/css');
                        sInline.appendChild(document.createTextNode(`
                            z-wizard-card .nav-pills { 
                                background: #eeeeee7a;
                                border-radius: .25rem;
                            }
                            z-wizard-card .nav-pills .nav-link { 
                                border-radius: .25rem;
                                border: 1px solid #DDD;
                                margin-right: 5px;
                                min-width: 75px;
                            }

                            z-wizard {
                                display: block;
                            }
                            z-wizard-contents {
                                height: 100%;
                                display: block;
                            }
                            z-wizard-finish {
                                height: 100%;
                                display: none;
                            }
                            
                            z-wizard.done .nav,
                            z-wizard.done z-wizard-card,
                            z-wizard.done .z-wizard-nav {
                                display: none !important;
                            }

                            z-wizard.done z-wizard-finish{
                                display: block
                            }

                            z-wizard .nav-item {
                                position: relative;
                            }
                            z-wizard .nav-item a {
                                padding-left: 25px;
                            }

                            z-wizard .nav-item:first-child a {
                                padding-left: 10px;
                            }

                            z-wizard .nav-item::after {
                                content: ' ';
                                width: 0px;
                                height: 0;
                                border-style: solid;
                                border-width: 20px 0 20px 20px;
                                border-color: transparent transparent transparent #e2e1e4;
                                position: absolute;
                                top: 0;
                                right: -18px;
                                z-index: 9;
                            }
                            z-wizard .nav-item {
                                background-color: #e2e1e4;
                            }
                            z-wizard .nav-item.active::after {
                                border-color: transparent transparent transparent #0083a6;
                            }

                            .z-wizard-next::after {
                                content: ' ';
                                width: 0px;
                                height: 0;
                                border-style: solid;
                                border-width: 18px 0 18px 18px;
                                border-color: transparent transparent transparent #0083a6;
                                position: absolute;
                                top: 0px;
                                right: -18px;
                                z-index: 9;
                            }

                            .z-wizard-previous::before {
                                content: ' ';
                                width: 0;
                                height: 0;
                                border-style: solid;
                                border-width: 18px 18px 18px 0;
                                border-color: transparent #747474 transparent transparent;
                                position: absolute;
                                top: 0px;
                                left: -18px;
                                z-index: 9;
                            }

                            z-wizard .nav-item:last-child::after {
                                content:none;
                            }
                        `));
                        head.appendChild(sInline);
                    }

                    init(){
                        this.doImport() ;

                        let innerHTML = this.innerHTML ;
                        const oldContents = this.querySelector(".tab-content") ;
                        if(oldContents){
                            //initial contents was already moved to the contents sub div
                            innerHTML = oldContents.innerHTML ;
                        }
                        this.innerHTML = "" ;

                        const clone = document.importNode(template.content, true);
                        this.appendChild(clone);

                        this.ul = this.querySelector("ul.nav") ;
                        this.contents = this.querySelector(".tab-content") ;
                        this.btNext = this.querySelector(".z-wizard-next") ;
                        this.btPrevious = this.querySelector(".z-wizard-previous") ;
                        this.btFinish = this.querySelector(".z-wizard-finish") ;

                        if(this.hasAttribute("z-finish-label")){
                            this.btFinish.innerHTML = this.getAttribute("z-finish-label") ;
                        }else{
                            this.btFinish.innerHTML = tr("global.finish") ;
                        }

                        this.btNext.addEventListener("click", ()=>{
                            const allLinks = this.ul.querySelectorAll(".nav-link") ;
                            for(let i=0; i<allLinks.length; i++){
                                if(allLinks[i].classList.contains("active")){
                                    allLinks[i+1].click() ;
                                    break;
                                }
                            }
                        }) ;
                        this.btPrevious.addEventListener("click", ()=>{
                            const allLinks = this.ul.querySelectorAll(".nav-link") ;
                            for(let i=0; i<allLinks.length; i++){
                                if(allLinks[i].classList.contains("active")){
                                    allLinks[i-1].click() ;
                                    break;
                                }
                            }
                        }) ;
                        this.btFinish.addEventListener("click", ()=>{
                            if(!this.checkStep(this.selectedTabId)){ return ; }
                            this.dispatchEvent(new CustomEvent("finish"));
                            this.classList.add("done") ;
                        }) ;

                        this.contents.innerHTML = innerHTML ;
                    }

                    checkStep(stepId){
                        const currentContent = this.querySelector("#"+stepId+"-contents") ;
                        if(currentContent){
                            let globalErrors = [] ;
                            currentContent.classList.add("was-validated") ;
                            let invalidFields = currentContent.querySelectorAll(":invalid") ;
                            for(let i=0; i<invalidFields.length; i++){
                                const invalidEl = invalidFields[i] ;
                                const message = invalidEl.validationMessage ;
                                if(message){
                                    let parentEl = invalidEl.closest(".form-group")||invalidEl ;
                                    let feedbackEl = parentEl.querySelector(".invalid-feedback") ;
                                    if(feedbackEl){
                                        feedbackEl.innerHTML = message ;
                                    }
                                    let labelEl = parentEl.querySelector("label") ;
                                    let label = "" ;
                                    if(labelEl){
                                        label = labelEl.innerHTML;
                                    }
                                    globalErrors.push({
                                        el: parentEl,
                                        field: invalidEl.getAttribute("z-bind"),
                                        label: label,
                                        msg: (label?label+" : ":"")+message
                                    }) ;
                                }
                            }

                            if(globalErrors.length === 0){
                                currentContent.classList.remove("was-validated") ;
                            }else{
                                error(globalErrors.map(function(e){ return "<p>"+e.msg+"</p>" ;}).join("")) ;
                                return false;
                            }
                        }
                        return true;
                    }
                    
                    showTab(zTabId){
                        if(zTabId && zTabId.id){
                            zTabId = zTabId.id.replace(/-contents$/, "");
                        }

                        if(this.selectedTabId){
                            //check tab before moving
                            const allTabs = this.querySelectorAll("z-wizard-card") ;
                            let newIndex = 0;
                            let currentIndex = 0;
                            for(let i=0; i<allTabs.length; i++){
                                if(allTabs[i].id.replace(/-contents$/, "") === zTabId){
                                    newIndex = i;
                                }
                                if(allTabs[i].id.replace(/-contents$/, "") === this.selectedTabId){
                                    currentIndex = i;
                                }
                            }
                            if(newIndex>currentIndex){
                                for(let i=currentIndex; i<newIndex; i++){
                                    if(!this.checkStep(allTabs[i].id.replace(/-contents$/, ""))){
                                        this.showTab(allTabs[i].id.replace(/-contents$/, "")) ;
                                        return;
                                    }
                                }
                            }
                        }

                        
                        const tabByRealId = this.querySelector('[z-real-id="'+zTabId+'"]') ;
                        if(tabByRealId){
                            zTabId = tabByRealId.id.replace(/-contents$/, "");
                        }
                        const currentTitle = this.ul.querySelector("#"+zTabId+"-title") ;
                        const allTitles = this.ul.querySelectorAll("a.nav-link") ;
                        this.selectedTabId = zTabId;
                        let previousTitle = null;
                        let nextTitle = null;
                        for(let i=0; i<allTitles.length; i++){
                            let t = allTitles[i] ;
                            if(t !== currentTitle){
                                t.classList.remove("active");
                                t.parentElement.classList.remove("active");
                                t.classList.remove("show");
                            }else{
                                if(i>0){
                                    previousTitle = allTitles[i-1];
                                }
                                if(i<allTitles.length-1){
                                    nextTitle = allTitles[i+1];
                                }
                            }
                        }
                        if(currentTitle){
                            currentTitle.classList.add("active");
                            currentTitle.classList.add("show");
                            currentTitle.parentElement.classList.add("active");
                        }
                        
                        if(previousTitle){
                            this.btPrevious.innerHTML = previousTitle.innerHTML ;
                            this.btPrevious.classList.remove("d-none");
                            this.btPrevious.linkedTitle = previousTitle ;
                        }else{
                            this.btPrevious.classList.add("d-none");
                        }
                        if(nextTitle){
                            this.btNext.innerHTML = nextTitle.innerHTML ;
                            this.btNext.classList.remove("d-none");
                            this.btNext.linkedTitle = nextTitle ;
                            this.btFinish.classList.add("d-none");
                        }else{
                            this.btFinish.classList.remove("d-none");
                            this.btNext.classList.add("d-none");
                        }


                        const currentContents = this.querySelector("#"+zTabId+"-contents") ;
                        const allContents = this.contents.querySelectorAll(".tab-pane") ;
                        for(let c of allContents){
                            if(c !== currentContents){
                                c.classList.remove("active");
                                c.classList.remove("show");
                                c.classList.remove("animate__animated") ;
                                c.classList.remove("animate__slideInLeft") ;
                                c.classList.remove("animate__faster") ;
                            }
                        }
                        if(currentContents){
                            currentContents.classList.add("active") ;
                            currentContents.classList.add("show") ;
                            currentContents.classList.add("animate__animated") ;
                            currentContents.classList.add("animate__slideInLeft") ;
                            currentContents.classList.add("animate__faster") ;
                        }
                    }

                    removedTab(zTabId){
                        if(zTabId && zTabId.id){
                            zTabId = zTabId.id;
                        }
                        zTabId = zTabId.replace(/-contents$/, "");
                        const title = this.querySelector("#"+zTabId+"-title") ;
                        if(title){
                            const li = title.closest("li") ;
                            if(li){
                                li.parentElement.removeChild(li) ;
                            }
                        }  
                    }

                    renderTabs(){
                        const allTabs = this.querySelectorAll("z-wizard-card") ;
                        const allSeenTitles = {} ;
                        let firstTabId = null;
                        for(let zTab of allTabs){
                            const zTabTitle = zTab.querySelector("z-wizard-title") ;
                            const zTabContents = zTab.querySelector("z-wizard-contents") ;
                            let zTabId = zTab.id ;
                            const tabIndex = Array.prototype.indexOf.call(this.querySelectorAll("z-wizard-card"), zTab) ;
                            if(zTabId){
                                zTabId = zTab.id.replace(/-contents$/, "") ;
                            }else{
                                zTabId = zTab.getAttribute("z-wizard-card-id")+"_"+tabIndex ;
                            }
                            if(!firstTabId){
                                firstTabId = zTabId ;
                            }
                            
                            if(zTabTitle && zTabContents){

                                if(!zTab.id){
                                    // first time
                                    zTab.id = zTabId+"-contents" ;
                                    zTab.setAttribute("aria-labelledby", zTabId+"-title") ;
                                    zTab.setAttribute("role", "tabpanel") ;
                                    zTab.className = "tab-pane fade" ;
                                    zTab.removeAttribute("zz-bind-prepared") ;
                                }
    
                                let aTitle = this.ul.querySelector("#"+zTabId+"-title") ;
                                let liTitle = null;
                                if(!aTitle){
                                    liTitle = document.importNode(templateTitle.content, true).children[0];
                                    aTitle = liTitle.querySelector("a");
                                    aTitle.id = zTabId+"-title" ;
                                    aTitle.href = "#"+zTabId+"-contents" ;
                                    // aTitle.setAttribute("data-target", "#"+zTabId+"-contents") ;
                                    aTitle.setAttribute("aria-controls", zTabId+"-contents") ;
                                    aTitle.addEventListener("click", (e)=>{
                                        e.preventDefault() ;
                                        this.showTab(zTabId) ;
                                    }) ;
                                    this.ul.appendChild(liTitle);
                                }else{
                                    liTitle = aTitle.parentElement ;
                                }
                                const allLiTitles = this.ul.querySelectorAll("li") ;
                                for(let i=0; i<allLiTitles.length; i++){
                                    const li = allLiTitles[i] ;
                                    if(li === liTitle){
                                        if(i !== tabIndex){
                                            if(tabIndex>=allLiTitles.length-1){
                                                this.ul.appendChild(li) ;
                                            }else{
                                                this.ul.insertBefore(li, allLiTitles[tabIndex]) ;
                                            }
                                        }
                                        break;
                                    }
                                }

                                allSeenTitles[zTabId+"-title"] = true ;
                                aTitle.innerHTML = zTabTitle.innerHTML ;
    
                                zTabTitle.style.display = "none" ;
                            }
                        }

                        //remove orphan titles
                        const allTitles = this.ul.querySelectorAll("a.nav-link") ;
                        for(let title of allTitles){
                            if(!allSeenTitles[title.id]){
                                const li = title.parentElement ;
                                li.parentNode.removeChild(li) ;
                            }
                        }

                        if(firstTabId && !this.querySelector(".tab-pane.active")){
                            this.showTab(firstTabId) ;
                        }
                    }

                }
                customElements.define(COMPONENT_NAME, WizardComponent);

                class WizardCardComponent extends HTMLElement {
                    constructor() {
                        super();
                        this.style.height = "100%" ;
                    }
                    
                    connectedCallback() {
                        if(this.id && !this.hasAttribute("z-real-id")){
                            this.setAttribute("z-real-id", this.id) ;
                        }
                        this.id = "";
                        this.setAttribute("z-wizard-card-id", "u"+uuidv4()) ;
                        this.zTabs = this.closest("z-wizard") ; 
                        this.renderTab();
                    }

                    disconnectedCallback(){
                        if(this.zTabs){
                            this.zTabs.removedTab(this.id) ;
                        }
                    }

                    renderTab(){
                        const zTabs = this.closest("z-wizard") ;
                        if(zTabs){
                            zTabs.renderTabs() ;
                        }
                    }
                }
                customElements.define("z-wizard-card", WizardCardComponent);
                
                class WizardTitleComponent extends HTMLElement {
                    constructor() {
                        super();
                        //rerender on content changes
                        const observer = new MutationObserver((mutations)=>{
                            if(mutations.some((m)=>m.type !== "attributes")){
                                this.connectedCallback() ;
                            }
                        });
                        observer.observe(this, { attributes: true, childList: true, subtree: true });
                       
                    }

                    connectedCallback(){
                        const zTab = this.closest("z-wizard-card") ;
                        if(zTab){
                            zTab.renderTab() ;
                        }
                    }
                }
                customElements.define("z-wizard-title", WizardTitleComponent);
                
                class WizardContentsComponent extends HTMLElement {
                    constructor() {
                        super();
                    }
                    
                    connectedCallback(){
                        const zTab = this.closest("z-wizard-card") ;
                        if(zTab && !zTab.hasAttribute("role")){
                            zTab.renderTab() ;
                        }
                    }
                }
                customElements.define("z-wizard-contents", WizardContentsComponent);

                class WizardFinishComponent extends HTMLElement {
                    constructor() {
                        super();
                    }
                }
                customElements.define("z-wizard-finish", WizardFinishComponent);
            }).catch((err)=>{
                throw err ;
            }) ;
        }).catch((err)=>{
            throw err ;
        }) ;
    }).catch((err)=>{
        throw err ;
    }) ;
}
